var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Autocomplete, Box, TextField } from "@mui/material";
import React from "react";
export const FilteredDropdown = ({ items, displayName, displayValue, label, value, onChange, }) => {
    return (React.createElement(Autocomplete, { fullWidth: true, options: items, autoHighlight: true, value: value, getOptionLabel: (option) => option[displayName], renderOption: (props, option) => {
            const { key } = props, optionProps = __rest(props, ["key"]);
            return (React.createElement(Box, Object.assign({ key: key, component: "li" }, optionProps), option[displayName]));
        }, renderInput: (params) => (React.createElement(TextField, Object.assign({}, params, { size: "small", label: label }))), onChange: (event, newValue) => {
            onChange(newValue != null ? newValue[displayValue] : null, newValue);
        } }));
};
export default FilteredDropdown;
